import { FC } from 'react';
import { JsonViewModeContextProvider, ViewTypes } from 'ui/treeView';
import { LocaleSettingsContextProvider } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';
import { LocalesQueryContextProvider } from 'modules/campaigns/lib/contexts/LocalesQueryContext';
import { ModalContextProvider } from 'utils/contexts/modal';
import { ModalProvider } from './context';
import { CampaignQueryContextProvider } from './context/CampaignQueryContextProvider';
import { EditableFieldsContextProvider } from './context/EditableFieldsContextProvider';
import { EditorFormProvider } from './context/EditorFormProvider';
import { EditSavedRowDesignProvider } from './context/EditSavedRowDesignContext';
import { ErrorValidationContextProvider } from './context/ErrorValidationContext';
import { MessageTypesQueryContextProvider } from './context/MessageTypesQueryContextProvider';
import { PreviewWithDataContextProvider } from './context/PreviewWithDataContextProvider';
import { QueryParamContextProvider } from './context/QueryParamContextProvider';
import { SendTestMsgContextProvider } from './context/SendTestMsgContextProvider';
import { TemplateQueryContextProvider } from './context/TemplateQueryContextProvider';
import { CommonModals, Modals } from './modals';
import { TemplateEditIndexPage, TemplateEditIndexProps } from './TemplateEditIndexPage';

export const TemplateEditContext: FC<React.PropsWithChildren<TemplateEditIndexProps>> = (props) => (
  <QueryParamContextProvider>
    <LocaleSettingsContextProvider>
      <LocalesQueryContextProvider>
        <CampaignQueryContextProvider>
          <TemplateQueryContextProvider>
            <EditorFormProvider>
              <ErrorValidationContextProvider>
                <MessageTypesQueryContextProvider>
                  <EditableFieldsContextProvider>
                    <PreviewWithDataContextProvider>
                      <SendTestMsgContextProvider>
                        <ModalContextProvider>
                          <ModalProvider>
                            <JsonViewModeContextProvider
                              identifier="raw-data"
                              defaultMode={ViewTypes.raw}
                            >
                              <EditSavedRowDesignProvider>
                                <TemplateEditIndexPage {...props} />
                                <CommonModals />
                                <Modals />
                              </EditSavedRowDesignProvider>
                            </JsonViewModeContextProvider>
                          </ModalProvider>
                        </ModalContextProvider>
                      </SendTestMsgContextProvider>
                    </PreviewWithDataContextProvider>
                  </EditableFieldsContextProvider>
                </MessageTypesQueryContextProvider>
              </ErrorValidationContextProvider>
            </EditorFormProvider>
          </TemplateQueryContextProvider>
        </CampaignQueryContextProvider>
      </LocalesQueryContextProvider>
    </LocaleSettingsContextProvider>
  </QueryParamContextProvider>
);
